<script setup>
import CloudWhatsapp from './CloudWhatsapp.vue';
</script>

<template>
  <div class="overflow-auto col-span-6 p-6 w-full h-full">
    <div class="px-6 py-5 rounded-2xl border border-n-weak">
      <CloudWhatsapp enable-calling-on-complete />
    </div>
  </div>
</template>
